import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config/api";

export default function ActivityLogs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_BASE_URL + "/api/admin-settings/activity-logs", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      });
      setLogs(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error(err);
      alert("Failed to load activity logs.");
    } finally {
      setLoading(false);
    }
  };

  const filteredLogs = logs.filter(log =>
    [log.user, log.action, log.details, log.role]
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between border-b pb-4 gap-4">
        <div>
          <h1 className="text-2xl font-extrabold text-slate-900 dark:text-white">Activity Logs</h1>
          <p className="text-sm text-slate-500 mt-1">Audit trail and logs of administrative actions, edits, and logins.</p>
        </div>
        <div className="flex items-center gap-2">
          <input
            type="text"
            placeholder="Search logs..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="border border-slate-250 dark:border-slate-700 bg-white dark:bg-slate-900 rounded-xl px-4 py-2 text-sm outline-none focus:border-blue-400 w-48 sm:w-64"
          />
          <button
            onClick={fetchLogs}
            className="p-2 border rounded-xl hover:bg-slate-50 dark:hover:bg-slate-700 text-slate-600 dark:text-slate-350"
          >
            <span className="material-symbols-outlined text-sm block">refresh</span>
          </button>
        </div>
      </div>

      <div className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 p-6 shadow-sm">
        {loading ? (
          <div className="text-center py-12 text-slate-500">Loading activity trail...</div>
        ) : filteredLogs.length === 0 ? (
          <div className="text-center py-12 text-slate-500 italic">No activity logs recorded yet.</div>
        ) : (
          <div className="relative border-l-2 border-slate-100 dark:border-slate-700 ml-4 pl-6 space-y-6 py-2">
            {filteredLogs.map((log) => {
              const date = new Date(log.createdAt);
              return (
                <div key={log._id} className="relative">
                  {/* Timeline dot */}
                  <span className="absolute -left-[31px] top-1.5 flex h-4.5 w-4.5 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900 ring-4 ring-white dark:ring-slate-800 text-blue-600 dark:text-blue-400">
                    <span className="h-2 w-2 rounded-full bg-blue-600"></span>
                  </span>
                  
                  {/* Log Card */}
                  <div className="space-y-1">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-bold text-slate-900 dark:text-white text-sm">{log.action}</span>
                      <span className="text-[10px] uppercase font-bold px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300">
                        {log.role}
                      </span>
                      <span className="text-xs text-slate-400">
                        {date.toLocaleDateString("en-GB")} {date.toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                    <p className="text-sm text-slate-650 dark:text-slate-400">
                      <strong>Actor:</strong> {log.user} {log.ipAddress && `(IP: ${log.ipAddress})`}
                    </p>
                    {log.details && (
                      <p className="text-xs text-slate-500 dark:text-slate-500 bg-slate-50 dark:bg-slate-900/50 p-2.5 rounded-lg border border-slate-100 dark:border-slate-800">
                        {log.details}
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
